"use strict";

/**
 * @classdesc
 * Container zur Verwaltung der featurebasierten Abfrage-Ergebnisse pro Layer.
 *
 * @class
 * @abstract
 * @extends gc.gis.widget.GCWidget
 * @memberof gc.gis.module.GCFeatureInfo
 * @author Christian Schmidt <c.schmidt@brain-scc.de>
 */
gc.gis.module.GCFeatureInfo.AbstractFeatureResultList = function()
{
    gc.gis.widget.GCWidget.call(this, {
        className: 'gc-featureinfo-featurelist'
    });

    /**
     * Hashmap, welche die Features enthält.
     * @type {Object}
     * @private
     */
    this._features = {};
};
gc.gis.module.GCFeatureInfo.AbstractFeatureResultList.prototype = Object.create(gc.gis.widget.GCWidget.prototype);

/**
 * Liefert die Anzahl der Features.
 *
 * @method
 * @return {int}
 * @public
 */
gc.gis.module.GCFeatureInfo.AbstractFeatureResultList.prototype.numFeatures = function()
{
    return Object.keys(this._features).length;
};

/**
 * Liefert die Features des Containers zurück.
 *
 * @return {gc.gis.feature.GCFeature[]}
 */
gc.gis.module.GCFeatureInfo.AbstractFeatureResultList.prototype.getFeatures = function()
{
    var features = [];
    for (var prop in this._features)
    {
        features.push(this._features[prop].feature);
    }

    return features;
};

/**
 * Prüft, ob ein Featur im Container enthalten ist.
 *
 * @method
 * @param {gc.gis.feature.GCFeature} feature
 * @return {boolean} Flag welches anzeigt, ob das Feature im Container enthalten ist
 * @public
 */
gc.gis.module.GCFeatureInfo.AbstractFeatureResultList.prototype.containsFeature = function (feature)
{
    var hash = this._hashFeature(feature);
    return this._features[hash] != undefined;
};

/**
 * Liefert den Index des Features in der Ergebnismenge.
 *
 * @method
 * @param {gc.gis.feature.GCFeature} feature
 * @return {int}
 * @public
 */
gc.gis.module.GCFeatureInfo.AbstractFeatureResultList.prototype.getFeatureIndex = function (feature)
{
    var hash = this._hashFeature(feature);
    if (this._features[hash]) {
        return this._features[hash].index;
    }

    return -1;
};

/**
 * Liefert eine Liste von Features, für die die angegebene Filterfunktion wahr ist.
 *
 * @method
 * @param {function} opt_filter_func
 * @return {gc.gis.feature.GCFeature[]}
 * @public
 */
gc.gis.module.GCFeatureInfo.AbstractFeatureResultList.prototype.filterFeatures = function (opt_filter_func)
{
    var features = [];
    var do_filter = (typeof opt_filter_func === 'function');

    for (var prop in this._features)
    {
        if(do_filter)
        {
            if(opt_filter_func.call(this, this._features[prop].feature))
            {
                features.push(this._features[prop].feature);
            }
        }
        else
        {
            features.push(this._features[prop].feature);
        }
    }

   return features;
};



/**
 * Fügt ein Feature zur Liste hinzu, sofern es nicht bereits Bestandteil der Liste ist.
 *
 * @method
 * @param {gc.gis.layer.GCAbstractLayer} layer
 * @param {gc.gis.feature.GCFeature} feature
 * @return {boolean} Flag welches anzeigt, ob das Feature hinzugefügt wurde.
 * @public
 */
gc.gis.module.GCFeatureInfo.AbstractFeatureResultList.prototype.addFeature = function (layer, feature)
{
    var exists = this.containsFeature(feature);

    if (!exists)
    {
        var hash = this._hashFeature(feature);
        var idx = this.numFeatures();

        this._features[hash] = {feature: feature, index: idx};
        this._createFeatureItem(layer, feature);

        this._fireEvent(gc.gis.module.GCFeatureInfoEvent.RESULT_FEATURE_ADD, {
            layer: layer,
            feature: feature,
            index: idx
        });
    }

    return !exists;
};

/**
 * Fügt ein Menge von Features zur Liste hinzu. Befor ein Feature hinzugefügt wird, erfolgt ein Prüfung, on des bereits
 * Bestandteil der Liste ist.
 *
 * @method
 * @param {gc.gis.layer.GCAbstractLayer} layer
 * @param {gc.gis.feature.GCFeature[]} features
 * @return {int} Anzahl der Features, die tatsächlich der Liste hinzugefügt wurden
 * @public
 */
gc.gis.module.GCFeatureInfo.AbstractFeatureResultList.prototype.addFeatures = function (layer, features)
{
    var ret = 0;
    for (var i=0; i<features.length; i++)
    {
        if (this.addFeature(layer, features[i])) {
            ret++;
        }
    }

    return ret;
};

/**
 * Setzt die Detail-Eigenschaften zu einem Feature.
 *
 * @param {gc.gis.layer.GCAbstractLayer} layer
 * @param {gc.gis.feature.GCFeature} feature
 * @param {string} content FeatureInfo-Inhalt
 * @param {gc.gis.module.GCFeatureInfoDetailResultTypes} contentType Conten-Type des FeatureInfo-Inhalts
 * @return {jQuery}
 */
gc.gis.module.GCFeatureInfo.AbstractFeatureResultList.prototype.setFeatureDetail = gc.gis.abstractMethod;

/**
 * Erzeugt einen Listeneintrag (Element) für ein Feature.
 *
 * @param {gc.gis.layer.GCAbstractLayer} layer
 * @param {gc.gis.feature.GCFeature} feature
 * @return {jQuery}
 * @protected
 */
gc.gis.module.GCFeatureInfo.AbstractFeatureResultList.prototype._createFeatureItem = gc.gis.abstractMethod;

/**
 * Erzeugt zum übergebenen Feature einen eindeutigen Hash.
 *
 * @param {gc.gis.feature.GCFeature} feature
 * @return {string} Feature-ID
 */
gc.gis.module.GCFeatureInfo.AbstractFeatureResultList.prototype._hashFeature = function(feature)
{
    return feature.getAttribute('featureLayer') + '_' + feature.getID().toString();
};


/**
 * Führt die Ereignishandlungsroutine zum Zoomen auf ein Feature aus.
 *
 * @param {gc.gis.layer.GCAbstractLayer} layer
 * @param {gc.gis.feature.GCFeature} feature
 * @protected
 */
gc.gis.module.GCFeatureInfo.AbstractFeatureResultList.prototype._doFeatureZoom = function (layer, feature)
{
	this._fireEvent(gc.gis.module.GCFeatureInfoEvent.RESULT_FEATURE_ZOOM, {
		layer: layer,
		feature: feature
	});
};